import { divisionItems } from './DivisionsSectionCarousel.data';

export const ACTIVE_ITEM_WIDTH_REM = 17.5;
export const INACTIVE_ITEM_WIDTH_REM = 16;

export const GAP_REM = 2.5;

export const CENTER_INDEX = Math.floor(5 / 2);

export const INITIAL_CAROUSEL_OFFSET_REM = 45.75;
export const CAROUSEL_ITEM_OFFSET_REM = INACTIVE_ITEM_WIDTH_REM + GAP_REM;

export const CAROUSEL_ITEMS = [
  ...divisionItems.slice(-CENTER_INDEX),
  ...divisionItems,
  ...divisionItems.slice(0, CENTER_INDEX + 1),
];

export const CAROUSEL_WIDTH_REM =
  CAROUSEL_ITEMS.length * (INACTIVE_ITEM_WIDTH_REM + GAP_REM) -
  (ACTIVE_ITEM_WIDTH_REM - INACTIVE_ITEM_WIDTH_REM);

export const SLIDE_INTERVAL = 3250; //ms
export const ANIMATION_DURATION = 325; //ms
